export default __webpack_public_path__ + "static/achievement_international-9056c2e4aab506c447f34c45458a4e6f.png";